<template>
  <div class="pc_only">
    <h2 class="kojin-title" style="background-color:orange"><slot>タイトル</slot></h2>
  </div>
  
  <span class="sp_only">
      <!-- ユーザー切替え対応 ユーザー名の表示とクリックした時にユーザー切替え画面を表示する -->
      <span class="sp-title" style="color:#FFF;background: #FF8400;">
        <span v-on:click="mypage()" style="padding-right: 35%;">← <slot>タイトル</slot></span>
        <input type="text" class="form-control form-select" v-if="GlobalData.user_name && selected.value=='yes'" v-bind:value="GlobalData.user_name" readonly="readonly" v-on:click="multipleusers_change">
        <input type="text" class="form-control" v-else-if="GlobalData.user_name  && selected.value=='no'" v-bind:value="GlobalData.user_name" readonly="readonly">
        <input type="text" class="form-control" v-else-if="GlobalData.$profile" value="未登録" readonly="readonly">
        <input type="text" class="form-control" v-else value="----------------------------------------------------------------------------------" readonly="readonly">
        
      </span>
  </span>
  <div class="p-2" style="margin-top:0;background-color:white">
    <!-- パンくずリスト -->
    <nav class="pc_only" style="--bs-breadcrumb-divider: '>';" aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item" v-on:click="home" style="cursor:pointer">Home</li>
        <li class="breadcrumb-item" v-on:click="mypage" style="cursor:pointer">マイページ</li>
        <li class="breadcrumb-item active" aria-current="page"><slot>タイトル</slot></li>
      </ol>
    </nav>
    
    <div id="manual_area" >

    <span v-on:click="manual_open"><img class="m_icon" src="../../images/mark/manual.png"  />設定のマニュアル</span>
    <span class="pc_only"  v-on:click="qanda_open"><img class="m_icon" src="../../images/mark/QandA.png"  />システムQ&A</span>
    <span class="sp_only"  v-on:click="qanda_open"><img class="m_icon" src="../../images/mark/QandA.png" style="height:35px"  /></span>
    </div>
      
    <br clear="all">

    <div id="button_area" >
      <button class="btn btn-primary mx-aut"
      style="font-size: 13.5px;width: 200px; height: 40px;margin:0 5px 10px 5px;padding: 0;background-color: #F5F5F5;color:#000;border:1px solid #000"
      v-on:click="profile()" >プロフィール編集</button>
      <br>
      
      <button class="btn btn-primary mx-aut"
      style="font-size: 13.5px;width: 200px; height: 40px;margin:0 5px 10px 5px;padding: 0;background-color: #F5F5F5;color:#000;border:1px solid #000"
      v-on:click="renewal()"  v-if="GlobalData.$identities == null">パスワード変更</button>  
      <!--
      <br>
      <button class="btn btn-primary mx-aut"
      style="font-size: 13.5px;width: 200px; height: 40px;margin:0 5px 10px 5px;padding: 0;background-color: #F5F5F5;color:#000;border:1px solid #000"
        v-on:click="mail_change()" v-if="GlobalData.$identities == null">メールアドレス変更</button>
        <br>-->
    </div>
    
    <div id="acount_area" >
      <span style="cursor:pointer;width:200px"
        v-on:click="Logout_check()"><u>ログアウト</u></span>  
        <br>
      <span style="cursor:pointer;width:200px"
        v-on:click="Delete_check()" ><u>アカウントを削除</u></span>
    </div>
  </div>
  <!-- 家族フラグの表示 -->
  <div class="family-radio-group" role="radiogroup" aria-label="家族参加">  
    <span style="font-size:1.5rem">■</span>家族（複数人）登録を変更しますか？&nbsp;
      <span class="sp_only" style="height:0px;"> <br> </span>
    <span>
      <input id="family-yes" class="family-radio-input" type="radio" name="family" value="yes" v-model="selected.value" v-on:change="joinFamily_check" />
        <label class="family-radio-btn" for="family-yes" style="width: 80px;text-align: center;">はい</label>&nbsp;
      <input id="family-no" class="family-radio-input" type="radio" name="family" value="no" v-model="selected.value" v-on:change="joinFamily_check" />
        <label class="family-radio-btn" for="family-no" style="width: 80px;">いいえ</label>

    </span>
  </div><br>
     <!-- スマホ専用ボタン（フローティングメニューの上に配置） -->
     <div class="vy-responsive-menu-container floating_over"  style="
          margin-bottom: 50px;
          padding: 10px 0;
          background: rgba(0, 0, 0, .5);
          border: 0px;
          justify-content: space-evenly;">
          <button class="btn btn-primary mx-aut" style="width: 45%; height: 50px;padding: 0;background-color: white;color:#4175d0;border:1px solid #000"  v-on:click="mypage()">戻る</button>
          
      </div>
      <!--メッセージを表示するモーダルウィンドウ-->
      <component v-bind:is="contentMessage"
                v-bind:message_text="message"
                v-bind:message_cat="message_cat"
                v-bind:message_flag="message_flag"
                @close_message="Close_message"
                @ok_message="OK_message"/>


      
</template>

<script setup>
/* eslint-disable */ 
import { useRouter,useRoute } from 'vue-router'
import { GlobalData, DateSetting,TimeSetting,DateTimeSetting } from '../js/userdata.js'
import AWS from 'aws-sdk';
import { ref, computed } from 'vue';
import axios from 'axios'

/* メッセージを表示するモーダルウィンドウ */
import MessageModal from '../common/MessageModal.vue'  

let message = ref("")//表示するメッセージ
let message_cat = ref(0)// メッセージのカテゴリ（0：OKのみ、1：OK or キャンセルの選択式）
let message_method = ref("")// こちら（親コンポーネント）に帰った時、どの処理（関数）を行うのか（message_catが1の時のみ）
let message_flag = ref(false)//表示・非表示フラグ

/* 表示する子コンポーネント関係の情報 */
const contentMessage = ref('')// 表示する子コンポーネントの情報（メッセージ表示エリア）
contentMessage.value = null // 表示する子コンポーネント


//const fileInput = ref(null);
const router = useRouter()
const route = useRoute()
const prop = defineProps(['param'])

import { useCookies } from 'vue3-cookies'
const { cookies } = useCookies()

// URLから閲覧している社協の英名を取得
let cityname = route.params.shakyo

// 所属する社協のデータ
const Shakyo_data = prop.param.Shakyo_data

const selected = ref('no')  // 家族フラグの設定　初期値"no"

selected.value = ref(prop.param.selected ? 'yes' :'no')  // 家族フラグの設定

let account_userid = prop.param.account_userid  // 家族の中のアカウントを所有しているユーザーID
let family_count = prop.param.family_count  //  アカウントユーザー以外の家族数

// 家族フラグのチェック
function joinFamily_check(e) {
    // 家族かどうかの選択で、既に家族の登録が出来ている人は、「いいえ」に出来ない。すべての家族を消してからにする
    if(e.target.value == 'no' && family_count >= 1){
        message.value = "既に家族が登録されています。すべての家族を削除してから再度実行をお願いします。";
        message_cat.value = 0;
        message_flag.value = true;
        message_method.value = "retry";
        contentMessage.value = MessageModal
    } else {
        // 家族の有無の登録を行う。
        family_flg_entry(e)
    }
}
// 家族フラグの登録処理
function family_flg_entry(e) {
  let user_data = {
      taikenuser_id:account_userid,
      family:e.target.value == 'yes'? true :false
  }
  // 親コンポーネントへユーザーの更新内容を送る
  emit('call',{ cmd:'user_family_koshin', user_data:user_data, multipleprofile:false })
}
// 家族フラグラジオボタンを変更した時の処理
const multipleusers_change = () =>{
    emit('call', { cmd:'multipleprofile_switch',id:GlobalData.user_id})
}

const emit = defineEmits(['call'])
emit('call', { cmd:'page_scroll'})


//------------------- 体験プログラム一覧表示へ
const home = () => { 
  router.push("/"+cityname+"/Taiken" ) 
}
const mypage = () => { 
  router.push("/"+cityname+"/Taiken/mypage" ) 
}

// メールアドレス変更
const mail_change = () =>{
  message.value = "準備中です。";
  message_cat.value = 0;
  message_flag.value = true;
  message_method.value = "mail_change";
  contentMessage.value = MessageModal

}

// ログアウトする前に確認
const Logout_check = function(){
  message.value = "ログアウトしますか？\n※次回ログインのために、ログイン方法を忘れないようにしてください。";
  message_cat.value = 1;
  message_flag.value = true;
  message_method.value = "logout";
  contentMessage.value = MessageModal
  
}

// ログアウト移動
const log_out = function() {
    emit('call', { cmd:'logout',id:''})
}

// 削除する前に確認
const Delete_check = function(){
    // 既に家族の登録が出来ている人は、アカウントの削除は出来ない。すべての家族を消してからにする
  if(family_count >= 1){
      message.value = "既に家族が登録されています。すべての家族を削除してから再度実行をお願いします。";
      message_cat.value = 0;
      message_flag.value = true;
      message_method.value = "retry";
      contentMessage.value = MessageModal
  } else {
      message.value = "アカウントを削除しますか？\n※削除後、復旧はできません。";
      message_cat.value = 1;
      message_flag.value = true;
      message_method.value = "delete";
      contentMessage.value = MessageModal
  }

}

// 体験アカウントを削除する
let Delete_set = function() {
  // 削除時は、cookieの「前回のログイン方法」を削除する
  if(cookies.isKey('last_login')){
    cookies.remove('last_login')
  }
  emit('call',{cmd:'user_delete'});
}


// 体験プログラムキャンセル時、同時にキャンセルする事前説明会を抽出する（廃止）
// メッセージを表示するウィンドウでOKを押された時
let OK_message = function(){ 
    Close_message();//メッセージを表示するウィンドウを閉じる

    if(message_method.value == "delete"){
      // アカウントを削除しますか？
      Delete_set()
    }else 
    if(message_method.value == "logout"){
      // ログアウトしますか？
      log_out()
    }

    // 家族かどうかの選択で、既に家族の登録が出来ている人は、「いいえ」に出来ないので「はい」に戻す
    if(message_method.value == "retry"){
        selected.value = ref('yes')   // 「はい」に修正する
    }

}

// メッセージを表示するウィンドウを閉じる
let Close_message = function(){
    message_flag.value = false;
    contentMessage.value = null
}

let manual_open = function(){
    let url = "https://zest-newsprint-e3e.notion.site/165c0be34f8f808dbe68e181283c330f"
    window.open(url,"_blank")
}

// Q&Aを開く
const qanda_open = () =>{

  let url = "https://zest-newsprint-e3e.notion.site/Q-A-175c0be34f8f801998fac72f169fb66b"
  window.open(url,"_blank")
}     

// パスワード変更移動
const renewal = function() {
    router.push('/'+cityname+'/Taiken/renewal')
}

// プロフィール編集移動
const profile = function() {
    router.push('/'+cityname+'/Taiken/profile')
}

</script>
<style scoped>
.taiken_table{
  cursor:pointer;
}
.taiken_table:hover{
  
  background-color:royalblue;
}


#acount_area{
  margin:10px auto;
    
    display: flex;justify-content: space-evenly;
    max-width: 400px;;
}


@media screen and (min-width: 961px) {

/* PC版 */

  .floating_over,.sp_button_area{
      display: none
  }
  #button_area{
    display: flex;
    justify-content: center;
  }
}
@media screen and (max-width: 960px) {

  /* スマホ版 */

  .floating_over,.sp_button_area{
      display: flex
  }
  #button_area{
    display: flex;justify-content: center;flex-direction: column;align-items: center;
    margin-top:10px
  }
}
/* ラジオボタン用のcss
/* ラジオ本体は画面外に（キーボード/スクリーンリーダー対応のsr-only） */
.family-radio-group {
  gap: 8px;
}

.family-radio-input {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}

/* 通常ボタン見た目 */
.family-radio-btn {
  user-select: none;
  cursor: pointer;
  padding: 8px 16px;
  border-radius: 10px;
  border: 1px solid #c9ced6;
  background: linear-gradient(#f7f9fc, #eef2f7);
  box-shadow:
    0 1px 2px rgba(0, 0, 0, 0.08),
    inset 0 0 0 rgba(0, 0, 0, 0);
  font-weight: 600;
  transition: box-shadow 0.15s, transform 0.05s, background 0.15s;
}

.family-radio-btn:hover {
  box-shadow:
    0 2px 5px rgba(0, 0, 0, 0.1),
    inset 0 0 0 rgba(0, 0, 0, 0);
}

.family-radio-input:focus-visible + .family-radio-btn {
  outline: 3px solid #7aa9ff;
  outline-offset: 2px;
}

/* 押し込み表現 */
.family-radio-btn:active {
  transform: translateY(1px);
}

/* 選択時（へこんだ見た目） */
#family-yes:checked + .family-radio-btn,
#family-no:checked + .family-radio-btn {
  background: linear-gradient(#e9eef6, #dae3f1);
  box-shadow: inset 0 3px 6px rgba(0, 0, 0, 0.18);
  border-color: #9fb3cc;
  transform: translateY(1px);
}
</style>
